import React from 'react';
import { SvgIcon } from '@mui/material';

const CameraDisabled = ({ ...props }) => (
    <SvgIcon {...props} width="32px" height="32px" viewBox="0 0 32 32" version="1.1">
        <g id="Style-Guide" stroke="none" strokeWidth="1" fill="inherit" fillRule="evenodd">
            <g transform="translate(-576.000000, -2276.000000)" id="Icons">
                <g transform="translate(48.000000, 2212.000000)">
                    <g id="Camera-Disabled-Icon" transform="translate(528.000000, 64.000000)">
                        <g id="1.-Icon/Camera/Inactive">
                            <path
                                d="M4.2701,4.27 C4.6311,3.91 5.2151,3.91 5.5761,4.27 L5.5761,4.27 L27.7291,26.424 C28.0901,26.785 28.0901,27.369 27.7291,27.729 C27.5491,27.91 27.3121,27.999 27.0761,27.999 C26.8411,27.999 26.6041,27.91 26.4241,27.729 L26.4241,27.729 L4.2701,5.576 C3.9101,5.215 3.9101,4.631 4.2701,4.27 Z M5.6819,8.3996 L19.7349,22.4536 C19.3449,23.1866 18.6489,23.6846 17.8529,23.6846 L17.8529,23.6846 L6.2149,23.6846 C4.9979,23.6846 4.0009,22.5336 4.0009,21.1276 L4.0009,21.1276 L4.0009,10.8716 C4.0009,9.6796 4.7209,8.6796 5.6819,8.3996 L5.6819,8.3996 Z M26.6962,9.1646 C27.1882,8.6966 28.0012,8.8876 28.0012,9.5666 L28.0012,9.5666 L28.0012,22.4336 C28.0012,23.1116 27.1882,23.3026 26.6962,22.8356 L26.6962,22.8356 L21.7312,17.8636 L21.7312,14.1366 Z M17.8523,8.3156 C19.0703,8.3156 20.0673,9.4666 20.0673,10.8716 L20.0673,10.8716 L20.0673,17.3476 L11.0363,8.3156 Z"
                                id="Combined-Shape"
                            />
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </SvgIcon>
);
export default CameraDisabled;
